import React, { useState } from "react";
import SelectMethod from "./SelectMethod/SelectMethod";
import CreditCard from "./CreditCard/CreditCard";
import DebitCard from "./DebitCard/DebitCard";
import BankAccount from "./BankAccount/BankAccount";
import { useLead } from "_contexts/useLead";
import { useNavigate } from "react-router-dom";
import { useStats } from "_contexts/useStats";
import { useSettings } from "_contexts/useSettings";
import "./PaymentInformation.scss";

function PaymentInformation(props) {
  const [selectedMethod, setSelectedMethod] = useState(undefined);
  const pageSettings = props.settings?.settings;
  const navigate = useNavigate();
  const { settings } = useSettings();
  const { lead, reload } = useLead();
  const { updateStats } = useStats();

  const onSave = async () => {
    if (props?.settings?.next) {
      await reload();
      await updateStats({
        application_id: lead.id,
        self_enrollment_id: settings.id,
        page: props?.settings?.name,
        drop_off_page: props?.settings?.next || props?.settings?.name,
      });
      navigate(`/${props?.settings?.next}`);
    }
  };

  return !selectedMethod ? (
    <SelectMethod
      setSelectedMethod={setSelectedMethod}
      title={pageSettings.title}
      subtitle={pageSettings.subtitle}
    />
  ) : (
    <>
      {selectedMethod === "credit-card" && (
        <CreditCard
          setSelectedMethod={setSelectedMethod}
          applicationId={lead.id}
          onSave={onSave}
        />
      )}
      {selectedMethod === "debit-card" && (
        <DebitCard
          setSelectedMethod={setSelectedMethod}
          applicationId={lead.id}
          onSave={onSave}
        />
      )}
      {selectedMethod === "bank-account" && (
        <BankAccount
          setSelectedMethod={setSelectedMethod}
          applicationId={lead.id}
          onSave={onSave}
        />
      )}
    </>
  );
}

export default PaymentInformation;
